function getBaseUrl() {
    return process.env.REACT_APP_BASE_URL;
}

function getBaseUrlForKos() {
    return process.env.REACT_APP_BASE_URL_KL;
}

export { getBaseUrl, getBaseUrlForKos };
